import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const HelpDeskIssueTypeSchema = z.enum([
  'BUG',
  'FEATURE_REQUEST',
  'ACCESS_ISSUE',
  'DATA_ISSUE',
  'OTHER',
]);
export type HelpDeskIssueType = z.infer<typeof HelpDeskIssueTypeSchema>;

export const HelpDeskTicketSchema = z.object({
  ticketId: uuidSchema,
  hospitalId: uuidSchema.nullable().optional(),
  name: z.string().min(1).max(255),
  email: z.string().email().max(255),
  currentPath: z.string().max(500),
  issueType: HelpDeskIssueTypeSchema,
  subject: z.string().min(1).max(500),
  description: z.string().min(1),
  createdBy: uuidSchema.nullable().optional(),
  createdAt: z.string().datetime(),
});
export type HelpDeskTicket = z.infer<typeof HelpDeskTicketSchema>;

export const CreateHelpDeskTicketRequestSchema = z.object({
  hospitalId: uuidSchema.optional(),
  name: z.string().min(1, 'Name is required').max(255),
  email: z.string().email('Invalid email address').max(255),
  currentPath: z.string().max(500),
  issueType: HelpDeskIssueTypeSchema,
  subject: z.string().min(1, 'Subject is required').max(500),
  description: z.string().min(1, 'Description is required'),
  createdBy: uuidSchema.optional(),
});
export type CreateHelpDeskTicketRequest = z.infer<typeof CreateHelpDeskTicketRequestSchema>;

export const CreateHelpDeskTicketMultipartSchema = CreateHelpDeskTicketRequestSchema.extend({
  attachment: z.file().optional().describe('Optional screenshot file attachment (emailed only, not stored)'),
});
export type CreateHelpDeskTicketMultipart = z.infer<typeof CreateHelpDeskTicketMultipartSchema>;
